/** Stav zápůjčky. */
export enum LoanState {
  ACTIVE = 'ACTIVE',
  RETURNED = 'RETURNED',
  CANCELED = 'CANCELED',
}
